export interface I18nConfig {
    defaultLang: string;
    availableLanguages: string[];
    translationsPath: string;
}

export const i18nConfig: I18nConfig = {
    defaultLang: 'it',
    availableLanguages: ['it'],
    translationsPath: 'i18n'
};
